/* istanbul ignore file */
export * from './FilterSettingsDesktop';
